// extracted by mini-css-extract-plugin
export var about = "about-module--about--d3b43";
export var about__item = "about-module--about__item--e4210";
export var about__list = "about-module--about__list--9f7f6";
export var about__numbers = "about-module--about__numbers--4a153";
export var about__numbersItem = "about-module--about__numbers-item--bd30d";
export var about__videoAndText = "about-module--about__video-and-text--83211";
export var about__videoBlock = "about-module--about__video-block--10efa";
export var about__videoWrap = "about-module--about__video-wrap--e9a98";